var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section__present"},[_c('h1',[_vm._v("Fastest")]),_c('span',{staticClass:"text__span1"},[_vm._v("Delivery")]),_c('h1',[_vm._v("In ShopT 2.0")]),_c('span',{staticClass:"text__span2"},[_vm._v("Prices as low as 0.59 USD.")])])
}]

export { render, staticRenderFns }